import * as React from "react";
import { TimePicker } from "baseui/datepicker";
import { colors, glyphs, icons } from "../../Styles";
import { useMemo, useState } from "react";
import { CreateFieldStyle, CreateFieldTypes, FieldStyles, FieldTypes } from "../../Definitions";

interface TimeField_Props {
  value: Date;
  onChange: (date: Date) => void;
  fieldStyle?: FieldStyles | string
  fieldType?: FieldTypes
  startEnhancer?: boolean
  textStart?: boolean
}

export default function TimeField({ value, onChange, fieldStyle, fieldType, startEnhancer = false, textStart = false }:TimeField_Props) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  // Colors from fieldStyle
  const { backgroundColor, fontStyle, scrollbarColor, hoverColor, dropdownColor } = useMemo(() => {
    var _Style = CreateFieldStyle(fieldStyle)
    return _Style
  }, [fieldStyle])

  const { dropdownBorderRadius, dropdownBorder, distancePaddingSelect, popoverPosition, showSelectArrow, arrowMargin, popoverWidth, optionContentMargin, width, popoverBorderRadius, optionContentWidth, height, controleContainerBorderRadiusOpen, dropdownListItemWidth, popoverTop, dropdownWidth, dropdownBoxShadow } = useMemo(() => {
    var _Style = CreateFieldTypes(fieldType)
    return _Style
  }, [fieldType])

  const handleChange = (date: Date | null) => {
    // Update the state only if date is not null
    if (date) {
      onChange(date); // Update parent with the new date
    }
  };

  // Handle padding based on the presence of the startEnhancer
  const handleDistance = () => {
    if (!startEnhancer && textStart) {
      return { padding: "0 0 0 19px" }
    } else {
      return { padding: distancePaddingSelect }
    }
  }

  return (
    <div style={{ position: "relative"}}>
      {/* startEnhancer */}
      <div>
        {!startEnhancer ? (<></>) : (
          <div style={{position: "absolute", zIndex: "2", top: "2.5px", left: "22px"}}>
            <glyphs.Time size={"25px"}/>
          </div>
        )}
      </div>
      {/* TimePicker */}
      <TimePicker
        value={value}
        onChange={handleChange}
        step={300}
        // minTime={new Date()}
        format="24"
      
        overrides={{
          Select: {
            props: {
              onOpen: () => setIsDropdownOpen(true), // Set dropdown state
              onClose: () => setIsDropdownOpen(false), // Unset dropdown state
              overrides: {
                // Input
                Root: { style: () => Object.assign({}, {
                  width: width,
                  margin: "0",
                } as React.CSSProperties )},
                ControlContainer: { style: () => Object.assign({}, {
                  ...backgroundColor,
                  height: height,
                  borderRadius: isDropdownOpen ? controleContainerBorderRadiusOpen : "10px",
                  display: "flex",
                  alignItems: "center",
                  boxSizing: "unset",
                  border: "none",
                  cursor: "pointer"
                } as React.CSSProperties )},
                ValueContainer: { style: () => Object.assign({}, {
                  ...fontStyle,
                  ...handleDistance()
                } as React.CSSProperties )},
                Input: { style: () => Object.assign({}, { 
                  ...fontStyle,
                  // paddingLeft: "2px",
                  'input::-webkit-inner-spin-button':{
                    appearance: 'none',
                  },
                  'input::-webkit-outer-spin-button':{
                    appearance: 'none',
                  },
                  '-moz-appearance': 'textfield', // For Firefox
                } as React.CSSProperties )},
                Placeholder: { style: () => Object.assign({}, {
                    ...fontStyle,
                    opacity: "30%",
                    //  marginLeft: "2px"
                  } as React.CSSProperties )},

                // Popover
                OptionContent: { style: () => Object.assign({}, { 
                  ...fontStyle,
                  width: optionContentWidth,
                  padding: "10px 16px",
                  margin: optionContentMargin,
                  // backgroundColor: colors.transparent,
                  ':hover': { ...hoverColor, borderRadius: "10px" }
                } as React.CSSProperties )},
                DropdownListItem: { style: () => Object.assign({}, { 
                  backgroundColor: colors.transparent,
                  width: dropdownListItemWidth,
                  padding: "0px",
                  display: "flex",
                  justifyContent: "center",
                } as React.CSSProperties )},
                Dropdown: { style: () => Object.assign({}, {
                  ...dropdownColor,
                  ...scrollbarColor,
                  // backgroundColor: colors.greyDarkPrimary,
                  borderRadius: dropdownBorderRadius,
                  // width: "198px",
                  width: dropdownWidth,
                  minWidth: dropdownWidth,
                  top: popoverTop,
                  position: "absolute",
                  boxSizing: "unset",
                  boxShadow: dropdownBoxShadow,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  scrollbarWidth: "thin",
                  maxHeight: "122px",
                  height: "auto",
                  border: dropdownBorder
                } as React.CSSProperties )},
                Popover: {
                  props: {
                    overrides: {
                      Inner: { style: () => Object.assign({}, {
                        ...backgroundColor,
                        borderRadius: popoverBorderRadius,
                      } as React.CSSProperties )},
                      Body: { style: () => Object.assign({}, {
                        ...backgroundColor,
                        borderRadius: popoverBorderRadius,
                        top: popoverTop,
                        position: popoverPosition,
                        width: popoverWidth,
                        maxHeight: "122px",
                        height: "auto",
                        boxShadow: dropdownBoxShadow,
                      } as React.CSSProperties )}
                    }
                  }
                },
                SelectArrow: {
                  props: {
                    overrides: {
                      Svg: { style: () => Object.assign({}, {
                        ...fontStyle,
                        marginRight: arrowMargin,
                        display: showSelectArrow
                      } as React.CSSProperties )}
                    }
                  }
                }
              }
            }
          },

          
        }}
      />
    </div>
  );
}